import React, { createContext, useState, useEffect, useContext } from 'react';
import { CartContext } from '../Cart/CartContext';
import axios from 'axios';

export const WishlistContext = createContext();

export const WishlistProvider = ({ children }) => {
  const [wishlistItems, setWishlistItems] = useState([]);
  const { addToCart } = useContext(CartContext);

  useEffect(() => {
    const storedWishlist = JSON.parse(localStorage.getItem('wishlistItems'));
    if (storedWishlist) {
      setWishlistItems(storedWishlist);
    }
  }, []);

  const saveWishlistToLocalStorage = (items) => {
    localStorage.setItem('wishlistItems', JSON.stringify(items));
  };

  // const addToWishlist = (product, selectedVariant) => {
  //   const productToSave = {
  //     ...product,
  //     price: selectedVariant ? selectedVariant.price : product.price,
  //     discount: selectedVariant ? selectedVariant.discount : product.discount,
  //     variant: selectedVariant ? selectedVariant.name || selectedVariant.id : null,
  //   };
  //   setWishlistItems((prev) => {
  //     const exists = prev.find((item) => item.id === product.id);
  //     const updatedWishlist = exists ? prev : [...prev, productToSave];
  //     saveWishlistToLocalStorage(updatedWishlist);
  //     return updatedWishlist;
  //   });



  // };


  //   const addToWishlist = async (product, selectedVariant) => {
  //   const user = JSON.parse(sessionStorage.getItem('userData')); // get logged user

  //   const productToSave = {
  //     ...product,
  //     price: selectedVariant ? selectedVariant.price : product.price,
  //     discount: selectedVariant ? selectedVariant.discount : product.discount,
  //     variant: selectedVariant ? selectedVariant.name || selectedVariant.id : null,
  //   };

  //   // If user is NOT logged in → store wishlist temporarily (session/local storage)
  //   if (!user) {
  //     setWishlistItems((prev) => {
  //       const exists = prev.find((item) => item.id === product.id);
  //       const updatedWishlist = exists ? prev : [...prev, productToSave];
  //       saveWishlistToLocalStorage(updatedWishlist);
  //       return updatedWishlist;
  //     });
  //     return; // stop here
  //   }

  //   // -------------------------
  //   // USER LOGGED IN → CALL API
  //   // -------------------------
  //   const userId = user?.id;
  //   const customerType = user?.business_type;
  //   const productId = product.id;
  //   const variantId = selectedVariant ? selectedVariant.id : null;

  //   const key = `${productId}_${variantId}`;

  //   // optimistic update (same as your toggleWishlist example)
  //   setWishlistItems((prev) => {
  //     const exists = prev.find((item) => item.id === product.id);
  //     const updated = exists ? prev : [...prev, productToSave];
  //     return updated;
  //   });

  //   try {
  //     // If product not exists -> ADD TO WISHLIST
  //     await axios.post(
  //       "https://api.glocart.in/pages/api/app/add-to-wishlist",
  //       {
  //         productId,
  //         variantId,
  //         userId,
  //         customerType,
  //       }
  //     );
  //   } catch (err) {
  //     console.error("Wishlist API error:", err);

  //     // revert optimistic update
  //     setWishlistItems((prev) => prev.filter((item) => item.id !== product.id));

  //     alert("Could not update wishlist. Please try again.");
  //   }
  // };


  const [wishlist, setWishlist] = useState({}); // mapping key -> true
  useEffect(() => {
     const user = JSON.parse(sessionStorage.getItem('userData'));
    if (!user?.id ) return;
    axios
      .get(`https://api.glocart.in/pages/api/app/wishlist/${user.id}`)
      .then((res) => {
        const wishMap = {};
        res.data.forEach((item) => {
          const key = `${item.productId}_${item.variantId}`;
          wishMap[key] = true;
        });
        setWishlist(wishMap);
      })
      .catch((err) => console.error('Error fetching wishlist:', err));
  }, []);



  const addToWishlist = async (product, selectedVariant) => {
    const user = JSON.parse(sessionStorage.getItem('userData')); // check login

    const productId = product.id;
    const variantId = selectedVariant ? selectedVariant.id : null;
    const key = `${productId}_${variantId}`;

    const productToSave = {
      ...product,
      price: selectedVariant ? selectedVariant.price : product.price,
      discount: selectedVariant ? selectedVariant.discount : product.discount,
      variant: selectedVariant ? selectedVariant.name || selectedVariant.id : null,
    };

    // =====================================================
    // 1️⃣ USER NOT LOGGED IN → LOCAL TEMP WISHLIST
    // =====================================================
    if (!user) {
      setWishlistItems((prev) => {
        const exists = prev.find((item) => item.id === product.id);

        // remove if exists (toggle)
        let updatedList;
        if (exists) {
          updatedList = prev.filter((item) => item.id !== product.id);
           alert("Removed from wishlist!");
        } else {
          updatedList = [...prev, productToSave];
           alert("Added to wishlist!");
        }

        saveWishlistToLocalStorage(updatedList);
        return updatedList;
      });

      return; // guest mode ends here
    }

    // =====================================================
    // 2️⃣ USER LOGGED IN → API WISHLIST (ADD / REMOVE)
    // =====================================================
    const userId = user?.id;
    const customerType = user?.business_type;

    const isWish = !!wishlist[key]; // check already in wishlist

    // optimistic UI update
    setWishlist((prev) => {
      const updated = { ...prev };
      if (isWish) delete updated[key];
      else updated[key] = true;
      return updated;
    });

    try {
      if (!isWish) {
        // ADD TO WISHLIST API
        await axios.post(
          "https://api.glocart.in/pages/api/app/add-to-wishlist",
          { productId, variantId, userId, customerType }
        );
        // alert("Added to wishlist!"); // ✅ ADD ALERT
      } else {
        // REMOVE FROM WISHLIST API
        await axios.post(
          "https://api.glocart.in/pages/api/app/remove-from-wishlist",
          { productId, variantId, userId, customerType }
        );
          // alert("Removed from wishlist!"); // ✅ REMOVE ALERT
      }
    } catch (err) {
      console.error("Wishlist API error:", err);

      // revert optimistic update
      setWishlist((prev) => {
        const updated = { ...prev };
        if (isWish) updated[key] = true; // revert
        else delete updated[key];
        return updated;
      });

      alert("Could not update wishlist. Please try again.");
    }
  };


  const removeFromWishlist = (id) => {
    setWishlistItems((prev) => {
      const updated = prev.filter((item) => item.id !== id);
      saveWishlistToLocalStorage(updated);
      return updated;
    });
  };

  

  const handleAddToCart = (item) => {
    // Use discount and price from item itself, fallback to zero/defaults
    const discount = item.discount || 0;
    const originalPrice = item.price || 0;

    // Calculate discounted price if discount exists
    const discountedPrice = discount
      ? Math.round(originalPrice - (originalPrice * discount) / 100)
      : originalPrice;

    addToCart(
      {
        productId: item.id,
        variantId: item.id, // keep as item.id, update if variants are added later
        name: item.name,
        image: item.image || item.image_1,
        price: discountedPrice,
        originalPrice: originalPrice,
        type: item.type || 'B2C', // fallback to B2C type
        stockQty: item.stockQty || 99, // default stock quantity if not available
      },
      1
    );

    removeFromWishlist(item.id);
    alert(`${item.name} has been moved to your cart.`);
  };

  return (
    <WishlistContext.Provider
      value={{
        wishlistItems,
        wishlist,
        addToWishlist,
        removeFromWishlist,
        handleAddToCart,
      }}
    >
      {children}
    </WishlistContext.Provider>
  );
};
